import { render, staticRenderFns } from "./snacks.template?vue&type=template&id=259b735a&lang=pug&"
import script from "./snacks.client?vue&type=script&lang=ts&"
export * from "./snacks.client?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('259b735a')) {
      api.createRecord('259b735a', component.options)
    } else {
      api.reload('259b735a', component.options)
    }
    module.hot.accept("./snacks.template?vue&type=template&id=259b735a&lang=pug&", function () {
      api.rerender('259b735a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/widgets/snacks/snacks.component.vue"
export default component.exports